"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactPopup = _interopRequireDefault(require("react-popup"));
var _reactGa = _interopRequireDefault(require("react-ga"));
var _Prompt = _interopRequireDefault(require("./Prompt"));
var _templateObject;
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
var FeedbackButtonDiv = _styledComponents["default"].button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  position: fixed;\n  bottom: 50%;\n  right: 0;\n  display: inline-block;\n  background-color: #3497c5;\n  color: white;\n  font-size: 1.2rem;\n  padding: 0.25rem 0.25rem 1rem 0.25rem;\n  transition: all 0.2s;\n  margin: -45px;\n  :hover {\n    background-color: #2f5767;\n    cursor: pointer;\n  }\n  box-shadow: 2px 2px 3px #999;\n  transform: rotate(-90deg);\n"])));
var FeedbackButton = /*#__PURE__*/function (_React$Component) {
  function FeedbackButton(props) {
    var _this;
    _classCallCheck(this, FeedbackButton);
    _this = _callSuper(this, FeedbackButton, [props]);
    _this.state = {
      smileyScore: null
    };
    _this.onClick = _this.onClick.bind(_this);
    _this.smileyChange = _this.smileyChange.bind(_this);
    _reactPopup["default"].registerPlugin("prompt", function (smileyScore, smileyChange, callback) {
      _reactPopup["default"].create({
        title: "Your feedback",
        content: /*#__PURE__*/_react["default"].createElement(_Prompt["default"], {
          feedbackFormLink: props.feedbackFormLink,
          onSelect: smileyChange
        }),
        buttons: {
          left: ["cancel"],
          right: smileyScore ? [{
            text: "Submit",
            className: "success",
            action: function action() {
              callback();
              smileyScore && _reactGa["default"].event({
                category: "Satisfaction",
                action: smileyScore.toString()
              });
              smileyScore && _reactPopup["default"].close();
            }
          }] : []
        }
      });
    });
    return _this;
  }
  _inherits(FeedbackButton, _React$Component);
  return _createClass(FeedbackButton, [{
    key: "smileyChange",
    value: function smileyChange(smileyScore) {
      var _this2 = this;
      this.setState({
        smileyScore: smileyScore
      }, function () {
        _reactPopup["default"].close();
        _this2.onClick();
      });
    }
  }, {
    key: "onClick",
    value: function onClick() {
      _reactPopup["default"].plugins().prompt(this.state.smileyScore, this.smileyChange, function () {
        _reactPopup["default"].alert("Thank you for submitting your feedback.");
      });
    }
  }, {
    key: "render",
    value: function render() {
      _reactGa["default"].initialize(this.props.gaId);
      _reactGa["default"].pageview(window.location.pathname + window.location.search);
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_reactPopup["default"], null), /*#__PURE__*/_react["default"].createElement(FeedbackButtonDiv, {
        onClick: this.onClick
      }, /*#__PURE__*/_react["default"].createElement("i", {
        className: "icon icon-functional",
        "data-icon": "n",
        style: {
          paddingRight: "0.5rem"
        }
      }), "Feedback"));
    }
  }]);
}(_react["default"].Component);
FeedbackButton.propTypes = {
  feedbackFormLink: _propTypes["default"].oneOf(["https://www.ebi.ac.uk/support/gxa", "https://www.ebi.ac.uk/support/gxasc"]).isRequired,
  gaId: _propTypes["default"].string.isRequired
};
var _default = exports["default"] = FeedbackButton;